'use client';

import CustomButtonRoot from './CustomButtonRoot';
import CustomButtonTooltip from './CustomButtonTooltip';

export const CustomButton = {
  Root: CustomButtonRoot,
  Tooltip: CustomButtonTooltip,
};
